export const ACTION_CONTEXT_MENU_WIDTH = 170;
//# sourceMappingURL=types.js.map